import type { TypeSetKey } from "../types/domain";

// Человекочитаемые ярлыки для typeSet. Используются в списке типов запусков
// и в редакторе. Зеркалит TYPE_SETS.label из client/src/lib/launchPresets.ts,
// но без таблицы `types` — только лейбл.
export const TYPE_SET_LABELS: Record<TypeSetKey, string> = {
  full: "Полный (email + анонс + заметка + лендинг)",
  email: "Только email / бот",
  content: "Контентный (анонсы + сторис + заметки)",
  empty: "Пустой — добавлю типы сам",
};

export const DEFAULT_COLORS: string[] = [
  "#5B5BD6",
  "#14B8A6",
  "#8B5CF6",
  "#F59E0B",
  "#EC4899",
  "#3B82F6",
  "#10B981",
  "#F97066",
  "#0EA5E9",
  "#7A849B",
];
